import { useState, useEffect, useCallback, useContext } from 'react';

import { useParams } from 'react-router-dom';

import Axios from '../../../../Assets/Axios/Axios';

import ToastContext from '../../../../Context/ToastContext';

import { organizeUserAddress } from '../../../../Helpers';

import { FindProfessionalOrdersByOrderStatus } from './../../../../Server/Query';

const useJobRequestsSection = orderStatus => {
  const { showToastMessage } = useContext(ToastContext);
  const [jobRequests, setJobRequests] = useState([]);

  const { professionalID } = useParams();

  const getAndUpdateJobRequests = useCallback(async () => {
    const { data, errors } = await Axios(FindProfessionalOrdersByOrderStatus({
        orderStatus,
        professionalID,
      }));

    if (errors) {
      showToastMessage('Oops! Something went wrong!,Unable get job details');
      return undefined;
    }

    const orders = data.orders.map(order => ({
      referenceId: order.id,
      name: `${order.user.firstName ?? ''} ${order.user.lastName ?? ''}`.trim(),
      date: new Date(order.orderDate).toLocaleDateString(),
      place: organizeUserAddress(order.user?.userLocation),
      phoneNo: order.user.mobileNumber,
      note: order.serviceNote,
    }));

    setJobRequests(orders);
  }, [orderStatus, professionalID, showToastMessage]);

  useEffect(() => {
    getAndUpdateJobRequests();
  }, [getAndUpdateJobRequests]);

  return { jobRequests, getAndUpdateJobRequests };
};

export default useJobRequestsSection;
